<template>
  <div class="forum-area">
    <h2 class="area-title typo-headline-5">{{ title }}</h2>
    <div class="forum-sections">
      <div 
        v-for="section in sections" 
        :key="section.id" 
        class="forum-section"
        @click="goToSection(section)"
      >
        <div class="section-left">
          <div class="section-icon">
            <i class="material-icons">{{ section.icon || 'forum' }}</i>
          </div>
          <div class="section-title-container">
            <h3 class="section-title typo-headline-6">{{ section.title }}</h3>
          </div>
        </div>
        <div class="section-right">
          <div class="section-meta typo-caption">
            <span class="thread-count">{{ section.threadCount || 0 }} hilos</span>
            <span class="post-count">{{ section.postCount || 0 }} mensajes</span>
          </div>
          <div class="last-activity-meta typo-caption">
            <span v-if="section.lastActivityTimestamp"> 
              Último: {{ formatDate(section.lastActivityTimestamp) }} por 
              <router-link 
                v-if="section.lastActivityNodeId" 
                :to="{ name: 'ForumThread', params: { nid: section.lastActivityNodeId }, hash: '#latest' }" 
                @click.native.stop 
                class="last-post-link-vue"
              >
                {{ section.lastActivityAuthor || 'Desconocido' }}
              </router-link>
              <span v-else>{{ section.lastActivityAuthor || 'Desconocido' }}</span>
            </span>
            <span v-else>
              No hay actividad reciente
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ForumArea',
  props: {
    title: {
      type: String,
      required: true
    },
    sections: {
      type: Array,
      required: true
    }
  },
  methods: {
    formatDate(timestamp) {
      if (!timestamp) return 'Fecha desconocida';
      const date = new Date(timestamp * 1000);
      return date.toLocaleString('es-ES', { 
          day: '2-digit', 
          month: '2-digit', 
          year: 'numeric', 
          hour: '2-digit', 
          minute: '2-digit' 
      });
    },
    goToSection(section) {
      //
      // Navigate using the slug parameter
      if (section.slug) {
        this.$router.push({ 
          name: 'ForumSection', 
          params: { slug: section.slug } 
        });
      } else {
        // Missing slug – ignore navigation in production
      }
    }
  }
}
</script>

<style scoped>
.forum-area {
  background-color: var(--color-surface);
  border-radius: 15px;
  padding: 20px;
  margin-bottom: 20px;
}

.area-title {
  margin-top: 0;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--color-outline);
}

.forum-sections {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.forum-section {
  display: flex;
  justify-content: space-between;
  padding: 15px;
  border-radius: 8px;
  background-color: var(--color-active-surface);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
}

.forum-section:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.section-left {
  display: flex;
  align-items: center;
}

.section-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  text-align: right;
}

.section-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background-color: var(--color-highlight);
  color: var(--color-on-highlight, white);
  border-radius: 50%;
  margin-right: 15px;
  flex-shrink: 0;
}

.section-icon i {
  font-size: 24px;
}

.section-title-container {
  flex-grow: 1;
}

.section-title {
  margin: 0;
  color: var(--color-highlight);
}

.section-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  color: var(--color-text-secondary);
  margin-bottom: 5px;
}

.last-activity-meta {
  color: var(--color-text-secondary);
}

.last-post-link-vue {
  color: var(--color-highlight);
  text-decoration: none;
}

@media (max-width: 768px) {
  .forum-section {
    flex-direction: column;
  }
  
  .section-right {
    align-items: flex-start;
    margin-top: 10px;
    text-align: left;
  }
  
  .section-meta {
    align-items: flex-start;
  }
}
</style> 